import { useId } from 'react';
import { SvgIconProps } from './icon-props';

export default function ItemRemove({ height = 40, width = 40 }: SvgIconProps) {
	// `<defs>` ids must be unique per document - a hardcoded id breaks `<use>` resolution whenever more
	// than one instance of this icon (or its `ItemAdd` sibling, which used the same hardcoded id) renders
	// on the same page, since the browser resolves `#a` to whichever element defined it first.
	const pathId = useId();
	return (
		<svg
			viewBox="0 0 40 40"
			width={width}
			height={height}
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
		>
			<defs>
				<path id={pathId} d="M12.933 19.64h14.8v1.6h-14.8z" />
			</defs>
			<g fillRule="evenodd">
				<path
					d="M20 40C8.954 40 0 31.046 0 20S8.954 0 20 0s20 8.954 20 20-8.954 20-20 20zm0-1c10.493 0 19-8.507 19-19S30.493 1 20 1 1 9.507 1 20s8.507 19 19 19z"
					fillRule="nonzero"
				/>
				<use xlinkHref={`#${pathId}`} />
			</g>
		</svg>
	);
}
